/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Settings_Tabs_LabelInputs */



/**
* | output |
* | --- |
* | "Live captioning settings tabs" |
*
* @param {Live_Caption_Settings_Tabs_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_settings_tabs_label = /** @type {((inputs?: Live_Caption_Settings_Tabs_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Settings_Tabs_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Onglets des paramètres de sous-titrage en direct")
	if (locale === "de") return /** @type {LocalizedString} */ ("Registerkarten für Live-Untertitelungseinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Schede delle impostazioni dei sottotitoli in tempo reale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вкладки настроек субтитров в реальном времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pestañas de configuración de subtítulos en directo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("实时字幕设置选项卡")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブキャプション設定タブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग सेटिंग्स टैब")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("guias de configurações de legendas ao vivo")
	return /** @type {LocalizedString} */ ("Live captioning settings tabs")
});